import { useContext } from "react";
import { DispatchContext } from "./DispatchContext";
import { StateContext } from "./StateContext";

export const initialProductEditState: any = {
    onSavePayload: {
        marketplace: {},
        source_product_id: '38274273640623',
        container_id: '6291645759663',
        target_marketplace: 'amazon',
        shop_id: '666',
        user_id: '625ec1b4243ee78af901d809',
    },
    initialProductData: {
        main_image: '',
        viewOnShopify: '',
        viewOnAmazon: '',
        asin: '',
        title: '',
        container_id: '',
        source_product_id: '',
        productLength: 0,
        hasVariants: false
    },
    product_attributes: [],
    product_type: {
        variantEdit: false,
        // variant: {}
    }
}

function useContextLayer() {
    const state = useContext<any>(StateContext);
    const dispatch = useContext<any>(DispatchContext);
    if (state === undefined || dispatch === undefined) {
        throw new Error("Context error!");
    }
    return { state, dispatch };
}

export default useContextLayer;